import { DATE_FILTER_CUSTOM } from '@dashboard/constants';
import { selectFilter, selectOptions } from '@dashboard/slices/filters';
import {
  selectData,
  selectFormattedMinimumWorkedTimeByWorkingGroup,
} from '@dashboard/slices/identificationStats';
import React from 'react';
import { useAppSelector } from '@app/hooks';
import { Chip, Title } from '@common/components';
import { useTranslation } from 'react-i18next';

function IdentificationStatsFiltersResume() {
  const { t } = useTranslation('dashboard\\IdentificationStatsView');
  const { t: selectT } = useTranslation('_common\\Select');
  const { t: gendersT } = useTranslation('dashboard\\Genders');
  const { t: publicationsT } = useTranslation('dashboard\\Publications');

  const { dateFilter } = useAppSelector(selectOptions);
  const { from, to } = useAppSelector(selectFilter);
  const formattedMinimumWorkedTimeByWorkingGroup = useAppSelector(
    selectFormattedMinimumWorkedTimeByWorkingGroup,
  );
  const {
    selectedClassIds,
    units,
    selectedUnits,
    selectedGender,
    publications,
    selectedPublicationsUsedByWorkingGroup,
    selectedGrouping,
  } = useAppSelector(selectData);

  const renderMultipleSelectedText = (selected, available) => {
    if (selected.length === 0) {
      return selectT('nSelected_none');
    }

    if (selected.length === available.length) {
      return selectT('all');
    }

    return selected.length;
  };

  return (
    <div style={{ marginTop: '2rem', marginBottom: '2rem' }}>
      <Chip color="secondary">
        <Title type="span" color="font-primary">
          {t('classGroup')}:
        </Title>{' '}
        <Title type="span" color="font-secondary">
          {selectedClassIds.length}
        </Title>
      </Chip>

      <Chip color="secondary">
        <Title type="span" color="font-primary">
          {t('period')}:
        </Title>{' '}
        <Title type="span" color="font-secondary">
          {dateFilter.value === DATE_FILTER_CUSTOM
            ? `${from} - ${to}`
            : dateFilter.label}
        </Title>
      </Chip>

      <Chip color="secondary">
        <Title type="span" color="font-primary">
          {t('selectEvaluationsLabel')}:
        </Title>{' '}
        <Title type="span" color="font-secondary">
          {renderMultipleSelectedText(selectedUnits, units)}
        </Title>
      </Chip>

      <Chip color="secondary">
        <Title type="span" color="font-primary">
          {gendersT('label')}:
        </Title>{' '}
        <Title type="span" color="font-secondary">
          {selectedGender?.value === 'all' || selectedGender === null
            ? gendersT('all')
            : gendersT(selectedGender?.value === 'M' ? 'male' : 'female')}
        </Title>
      </Chip>

      <Chip color="secondary">
        <Title type="span" color="font-primary">
          {publicationsT('selectFormatUsedByWorkingGroupLabel')}:
        </Title>{' '}
        <Title type="span" color="font-secondary">
          {renderMultipleSelectedText(
            selectedPublicationsUsedByWorkingGroup,
            publications,
          )}
        </Title>
      </Chip>

      <Chip color="secondary">
        <Title type="span" color="font-primary">
          {t('minimumWorkedTimeLabel')}:
        </Title>{' '}
        <Title type="span" color="font-secondary">
          {formattedMinimumWorkedTimeByWorkingGroup}
        </Title>
      </Chip>

      <Chip color="secondary">
        <Title type="span" color="font-primary">
          {t('reportFilterGroupingLevel')}:
        </Title>{' '}
        <Title type="span" color="font-secondary">
          {selectedGrouping
            ? {
                none: t('reportFilterGroupingNone'),
                center: t('reportFilterGroupingByCenter'),
                class: t('reportFilterGroupingByClass'),
              }[selectedGrouping]
            : t('reportFilterGroupingNone')}
        </Title>
      </Chip>
    </div>
  );
}

export default IdentificationStatsFiltersResume;
